/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BalanceUnitStatementEntryDebit
 */
export interface BalanceUnitStatementEntryDebit {
}

/**
 * Check if a given object implements the BalanceUnitStatementEntryDebit interface.
 */
export function instanceOfBalanceUnitStatementEntryDebit(value: object): value is BalanceUnitStatementEntryDebit {
    return true;
}

export function BalanceUnitStatementEntryDebitFromJSON(json: any): BalanceUnitStatementEntryDebit {
    return BalanceUnitStatementEntryDebitFromJSONTyped(json, false);
}

export function BalanceUnitStatementEntryDebitFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceUnitStatementEntryDebit {
    return json;
}

export function BalanceUnitStatementEntryDebitToJSON(json: any): BalanceUnitStatementEntryDebit {
    return BalanceUnitStatementEntryDebitToJSONTyped(json, false);
}

export function BalanceUnitStatementEntryDebitToJSONTyped(value?: BalanceUnitStatementEntryDebit | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

